import actionTypes from './actionTypes'
import confirmTypes from 'helpers/enums/confirmTypes'

const cartActions = {
	getCartData() {
		return {
			type: actionTypes.CART_GET_DATA,
		}
	},

	toggleCart(entityUID, entityType, onCart) {
		return {
			type: actionTypes.CART_TOGGLE,
			entityUID,
			entityType,
			onCart,
		}
	},

	cartItemFailed(entityUID, serverError) {
		return {
			type: actionTypes.CART_ITEM_FAILED,
			entityUID,
			serverError,
		}
	},

	confirmRemove(entityUID, entityType) {
		return {
			type: actionTypes.OPEN_CONFIRM,
			confirmType: confirmTypes.CART_REMOVE,
			confirmProps: {
				entityUID,
				entityType,
			},
		}
	},

	buyProduct(entityUID, entityType, libraryUID) {
		return {
			type: actionTypes.CART_BUY_PRODUCT,
			entityUID,
			entityType,
			libraryUID,
		}
	},

	buyProductSuccess(entityUID, libraryUID, entityType, payload, message) {
		return {
			type: actionTypes.CART_BUY_PRODUCT_SUCCESS,
			entityUID,
			libraryUID,
			entityType,
			payload,
			message,
		}
	},

	saveProduct(entityUID, entityType, libraryUID, friendlyUrl) {
		return {
			type: actionTypes.CART_SAVE,
			entityUID,
			entityType,
			libraryUID,
			friendlyUrl,
		}
	},

	cartDownloading(entityUID, entityType) {
		return {
			type: actionTypes.CART_DOWNLOADING,
			entityUID,
			entityType,
		}
	},

	gotoCart() {
		return {
			type: actionTypes.CART_GOTO,
		}
	},
}

export default cartActions
